import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions';
import withRouter from 'react-router/lib/withRouter';

class Pages extends Component {

	componentWillMount() {
		this.getSportPage();
	}
	componentDidUpdate(prevProps, prevState) {
		const { pathname } = this.props;
		if(pathname !== prevProps.pathname) {
			this.getSportPage();
		}
	}

	getSportPage = () => {
		const { getPage, params } = this.props;
		getPage(params.page);
	}

    render(){
 
    	const { sports, page } = this.props;

    	if(Object.keys(page).length <= 0) {
    		return (
    			<div className="page_content">
    				PAGE NOT FOUND
    			</div>
    		)
    	}
    	
    	const content = (html) => {
    		return {
    			__html: html
    		}
    	}


		return (
			<div className="page_content">
				<h3>{ page.title }</h3>
				<div dangerouslySetInnerHTML={ content(page.body) }/>
				<br/>
				<br/>
				{ sports.map((item, index) => {
					return (
						<iframe 
                            title={page.title}
							key={index}
							style={{width: 1024, height: 500}} src={ item } 
							seamless="seamless" 
							scrolling="no" 
							frameBorder="0"
                            allowTransparency="true"
							/>
					)
				})}
			</div>
		)
	}
}

export default withRouter(connect(
	(state, routeParams) => {
		const { sports, page } = state.pages
		const { params, location } = routeParams;
		const { pathname } = location;

		return {
            params,
            pathname,
            sports,
            page
		}
	},
	actions
)(Pages))


// WEBPACK FOOTER //
// ./src/pages/containers/Pages.js